/**
 * Tour ids for the three habitat scenarios.
 *
 * They live apart from the configs so a config can name a SIBLING (the online flow retires the
 * other two when the user captures something) without importing that sibling's whole module.
 *
 * These strings are a contract with the backend: the onboarding migration seeds
 * `user.tours[<id>] = { completedAt, completedTimes: 1 }` for users who are already past this,
 * and `deriveStatus` reads that as cleared. Renaming one silently un-suppresses those users.
 */
export const HABITAT_ONBOARDING_ONLINE_ID = 'habitatOnboardingOnline';
export const HABITAT_ONBOARDING_ASLEEP_ID = 'habitatOnboardingAsleep';
export const HABITAT_ONBOARDING_OUTAGE_ID = 'habitatOnboardingOutage';

export const HABITAT_ONBOARDING_IDS = [
  HABITAT_ONBOARDING_ONLINE_ID,
  HABITAT_ONBOARDING_ASLEEP_ID,
  HABITAT_ONBOARDING_OUTAGE_ID,
] as const;
